module.exports = __webpack_public_path__ + "static/media/Fennekin_gaussian2.2ee270e5.png";